@let item1Image = data.items[0]!.image!;
@let item2Image = data.items[1]!.image!;
@let item3Video = data.items[2]!.video!;
@let item4Image = data.items[3]!.image!;
@let item5Image = data.items[4]?.image!;
@let item6Text = data.items[5]?.text!;

<div class="centered-with-padding mx-auto py-7">
  <div class="flex flex-col gap-y-5 desk:gap-y-4">
    @if (data.title; as title) {
      <app-title [title]="title" size="h2" />
    }

    @if (data.description; as description) {
      <span>{{ description }}</span>
    }
  </div>
  <div class="grid grid-cols-2 gap-1 pt-7 desk:grid-cols-3 desk:grid-rows-3 desk:gap-4">
    <div
      class="group col-span-2 row-span-2 h-[300px] overflow-hidden rounded-3xl desk:order-1 desk:col-span-3 desk:row-span-full desk:h-[533px]">
      @if (item1Image) {
        <app-image
          [hoverEffect]="true"
          (click)="zoomImageRequested.emit(item1Image)"
          [image]="item1Image"
          [isPriority]="!isImageInPreviousBlocks"
          class="cursor-zoom-in" />
      }
    </div>

    <div class="group row-span-2 h-[300px] overflow-hidden rounded-3xl desk:order-2 desk:col-span-2 desk:h-[531px]">
      @if (item2Image) {
        <app-image
          [hoverEffect]="true"
          (click)="zoomImageRequested.emit(item2Image)"
          [image]="item2Image"
          [isPriority]="!isImageInPreviousBlocks"
          class="cursor-zoom-in" />
      }
    </div>

    <div class="row-span-2 h-[300px] overflow-hidden rounded-3xl desk:order-3 desk:h-[531px]">
      @if (item3Video) {
        <app-video [autoplay]="true" [isImagePriority]="!isImageInPreviousBlocks" [video]="item3Video" />
      }
    </div>

    @if (!data.hideLastItem) {
      <div class="group row-span-2 h-[300px] overflow-hidden rounded-3xl desk:order-4 desk:aspect-square desk:h-auto">
        @if (item4Image) {
          <app-image
            [hoverEffect]="true"
            (click)="zoomImageRequested.emit(item4Image)"
            [image]="item4Image"
            class="cursor-zoom-in" />
        }
      </div>

      <div
        class="group h-[calc(150px-.125rem)] overflow-hidden rounded-3xl desk:order-6 desk:aspect-square desk:h-auto">
        @if (item5Image) {
          <app-image
            [hoverEffect]="true"
            (click)="zoomImageRequested.emit(item5Image)"
            [image]="item5Image"
            class="cursor-zoom-in" />
        }
      </div>

      <div
        class="flex h-[calc(150px-.125rem)] flex-col justify-center gap-2 rounded-3xl bg-anis p-6 text-center desk:order-5 desk:aspect-square desk:h-auto desk:gap-9">
        @if (item6Text?.title; as title) {
          <app-title [title]="title" size="custom-15" />
        }
        @if (item6Text?.subtitle; as subtitle) {
          <span class="text-[10px] font-bold leading-[14px] desk:text-[14px] desk:leading-[19px]">{{ subtitle }}</span>
        }
      </div>
    }
  </div>
</div>
